import { SignOutLight } from 'emerald-icons/dist/SignOutLight';
import { accent0, gray5 } from 'emerald-ui/dist/globals/colors';
import { font } from 'emerald-ui/dist/globals/fonts';
import styled from 'styled-components';

export const LoginButton_Root = styled.button`
    display: flex;
    align-items: center;
`;

export const LoginButton_Icon = styled(SignOutLight)`
    margin-right: .5em;
    color: ${gray5};
    font-size: 1.5rem;
`;

export const LoginButton_Text = styled.div`
    color: ${accent0} !important;
    font-size: .875rem;
    font-family: ${font.light};
    line-height: 1rem;
    width: 4.5em; /* to make the text break into 2 lines */
    text-align: right;
`;
